import { z } from "zod";

// t("ACTIVE")
// t("IN_REVIEW")
// t("LAB_PENDING")
// t("LOCKED")
// t("BOARDING")
export const consultationStatusEnum = z.enum([
  "ACTIVE",
  "IN_REVIEW",
  "LAB_PENDING",
  "LOCKED",
  "BOARDING",
]);
export type ConsultationStatus = z.infer<typeof consultationStatusEnum>;
